export const foldersType = {
    backend: 'backend',
    public: 'public',
    styles: 'styles'
};
